import AccountVerificationSuccess from "./AccountVerificationSuccess";

export default AccountVerificationSuccess;
